import { create } from 'zustand';
import {persist, createJSONStorage} from 'zustand/middleware';

// El store es un simple contenedor de estado con acciones para modificarlo.
const useAuthStore = create(
  persist(
    (set) => ({
    token: null,
    user: null,
    players: [],
    activePlayer: null,

    // Acción centralizada para establecer el estado de autenticación completo.
    setAuthState: (data) => {
      const { token, user } = data;
      localStorage.setItem('token', token);
      const { players, active_player, ...userData } = user;
      set({ token, user: userData, players: players || [], activePlayer: active_player || null });
    },

    setActivePlayer: (playerId) => {
      set((state) => {
        const playerToSelect = state.players.find(p => p.id === parseInt(playerId, 10));
        return { activePlayer: playerToSelect || null };
      });
    },

    // Acción para limpiar todo el estado de autenticación.
    clearAuthState: () => {
      set({ token: null, user: null, players: [], activePlayer: null });
    },
  }),{
    name: 'auth-storage', // Nombre del almacenamiento persistente
    storage: createJSONStorage(() => localStorage), // Usar localStorage para persistencia
    //partialize: (state) => ({ token: state.token, user: state.user }), // Persistir solo token y user
  }
));

export default useAuthStore;